import React from 'react'

export default function Grid({ children, columns, attributes, className, style }){
    // console.log(columns)
    return(
        <div
            {...attributes}
            className={className}
            style={style}
            css={{
                display: 'grid',
                rowGap: 40,
                columnGap: 20,

                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                '@media(max-width: 1024px)': { gridTemplateColumns: 'repeat(2, 1fr)' },
                '@media(max-width: 576px)': { gridTemplateColumns: 'repeat(1, 1fr)' },
            }}
        >
            {children}
        </div>
    )
}
